import React from "react";
import { Button, Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "../PublishTrip.module.css";

const PublishTripHeader = ({ status, onNewDeparture }) => {
  const { t } = useTranslation();
  const normalizedStatus = status || "DRAFTS";

  const statusConfig = (() => {
    if (normalizedStatus === "PUBLISHED") {
      return {
        className: styles.statusPublished,
        label: t("commons.states.published"),
      };
    }

    if (normalizedStatus === "ARCHIVED") {
      return {
        className: styles.statusArchived,
        label: t("commons.states.archived"),
      };
    }

    if (normalizedStatus === "WAITING_FOR_APPROVAL") {
      return {
        className: styles.statusWaiting,
        label: t("commons.states.waiting"),
      };
    }

    return {
      className: styles.statusDraft,
      label: t("commons.states.darft"),
    };
  })();

  return (
    <div className={styles.cardHeader}>
      <div>
        <Text as="h1" className={styles.title} weight="bold">
          {t("tripPublication.publishTrip.title")}
        </Text>
        <Text as="p" className={styles.subtitle}>
          {t("tripPublication.publishTrip.subtitle")}
        </Text>
      </div>

      <div className={styles.headerActions}>
        <Text as="span" className={`${styles.statusBadge} ${statusConfig.className}`} weight="bold">
          {statusConfig.label}
        </Text>
        <Button
          primary={true}
          label={t("tripPublication.publishTrip.actions.newDeparture")}
          iconName="iconPlus"
          size="small"
          iconPosition="left"
          onClick={onNewDeparture}
        />
      </div>
    </div>
  );
};

export default PublishTripHeader;
